/// <reference path="vendor\jquery-1.4.1-vsdoc.js"/>
/// <reference path="Nis.js"/>

$(function() {
  Nis.Gui.init();
});

Nis.Gui = $.extend(Nis.Gui, {
  init: function() {
    Nis.Dialogs.init();
    Nis.Gui.Modal.init();
  },

  // template
  tmpl: function(template, dataObject) {
    var man = { id: '', cssclass: '', value: '', html: '', text: '' };
    dataObject = $.extend(man, dataObject);
    $.each(dataObject, function(key, val) {
      template = template.replace(new RegExp('{' + key.toString() + '}', 'g'), (val == null ? '' : val.toString().replace('$0', '&#36;0')));
    });
    return template;
  },

  // shortcut to return a jquery object from a template
  $tmpl: function(template, dataObject) {
    return $(Nis.Gui.tmpl(template, dataObject));
  },

  // shortcut for creating a dropdown options
  // Nis.Gui.opt(items, true) - Will include an empty option element as the first item
  // Nis.Gui.opt(items, true, true) - Will reverse Name and Value when creating the options elements
  opt: function(data) {
    var options = '';
    var includeEmptyInFront = (arguments.length >= 2) ? arguments[1] : false;
    var switchNameValue = (arguments.length >= 3) ? arguments[2] : false;

    if (includeEmptyInFront) options += '<option value=""></option>';

    $.each(data, function(name, value) {
      if (switchNameValue) {
        options += '<option value="' + name + '">' + value + '</options>';
      } else {
        options += '<option value="' + value + '">' + name + '</options>';
      }
    });
    return options;
  },

  showTip: function(tipElement, atElement, tipText) {
    // make sure that the element are jquery objects
    if (tipElement.jQuery == 'undefined') tipElement = $(tipElement);
    if (atElement.jQuery == 'undefined') atElement = $(atElement);

    $((tipElement.find('.tip-content').get(0) || $('<div class="tip-content"></div>').appendTo(tipElement).get(0)))
      .html(tipText);

    tipElement
      .place(atElement.offset().left, atElement.offset().top + atElement.outerHeight())
      .css('display', 'block');

    // todo: hide the tip after some time ?
  },

  hideTip: function(tipElement) {
    if (tipElement.jQuery == 'undefined') tipElement = $(tipElement);
    tipElement.hide();
  },

  showTinyStatus: function($element, message, messageClass, showTime) {
    if (!$element.hasClass('tiny_message')) return;

    var validClasses = ['busy', 'success', 'error', 'info', 'warning'];
    // remove and existing class
    for (var i = 0; i < validClasses.length; i++) {
      $element.removeClass(validClasses[i]);
    }

    // clear any existing hide timer
    if ($element.data('timer') != null) {
      clearTimeout($element.data('timer'));
      $element.data('timer', null);
    }

    if (showTime != null) {
      $element.data('timer', setTimeout(function() {
        $element.fadeOut(500);
      }, showTime));
    }

    if (messageClass == 'busy') {
      $element.html('&nbsp;');
    } else {
      $element.html(message);
    }
    $element.addClass(messageClass);
    $element.css('display', 'inline-block');
  }
});

Nis.Gui.Modal = {
  level: 0,

  events: {
    CLOSED: 'closed'
  },

  init: function() {
    var m = Nis.Gui.Modal;
    $('.dialog').each(function(i, o) {
      m.make($(o), $(o).hasClass('modal'));
    });
  },

  create: function() {
    return Nis.Gui.Modal.make($("<div />").addClass("dialog"));
  },

  wrap: function($element, title, cls) {
    var wrapper = $(Nis.Gui.tmpl('<div class="dialog"><div class="titlebar">{title}<div class="x-close closeDialog"></div></div><div class="content"></div></div>', {
      title: title ? title : ''
    }));

    if (cls) {
      wrapper.addClass(cls);
    }

    wrapper.find('.content').append($element);

    return wrapper;
  },

  make: function($element, modal, removeOnClose, onClose) {
    $element.jqm({
      modal: modal,
      overlay: 75,
      overlayClass: 'white_overlay',
      onShow: Nis.Gui.Modal.onModalShow,
      onHide: Nis.Gui.Modal.onModalHide
    });

    // move the element
    $('body').append($element);

    $element.hide = function() {
      Nis.Gui.Modal.hide(this);
    };

    if (removeOnClose) {
      $element.on(Nis.Gui.Modal.events.CLOSED, function() {
        $element.remove();
      });
    }

    if (_.isFunction(onClose)) {
      $element.on(Nis.Gui.Modal.events.CLOSED, onClose);
    }

    return $element;
  },

  hide: function($element) {
    $element.jqmHide();
  },

  show: function($element) {
    $element.jqmShow();
  },

  onModalShow: function(h) {
    Nis.Gui.Modal.level += 2;
    var scrollTop = $(document).scrollTop(),
      winWidth = $(document).width(),
      width = h.w.width(),
      deltaTop = 35;

    h.w.css('top', (scrollTop + deltaTop) + 'px');
    h.o.css('z-index', 3002 + Nis.Gui.Modal.level - 1);
    h.w.css('z-index', 3002 + Nis.Gui.Modal.level);
    if (winWidth > width) {
      h.w.css('left', Math.floor((winWidth - width) / 2) + 'px');
    } else {
      h.w.css('left', '0px');
    }
    h.w.jqmAddClose(h.w.find('.closeDialog'));
    h.w.show();

    // try to set focus to the first form element with class defaultFocus
    if (h.w.find('.defaultFocus').length > 0) {
      h.w.find('.defaultFocus').focus();
    }
  },

  onModalHide: function(h) {
    Nis.Gui.Modal.level -= 2;
    h.w.hide();
    h.o.remove();
    h.w.trigger(Nis.Gui.Modal.events.CLOSED, h.w);
  }
};

// *** Nis.Cookies
// wrapping the jquery cookie lib (jquery.cookie)
// Work in progress
Nis.Cookies = {
  Cookie: function(cookieName, cookieValue, cookieExpire, cookieDomain) {
    this.name = cookieName;
    this.value = cookieValue;
    this.expire = cookieExpire;
    this.domain = cookieDomain;
  },
  getCookie: function(cookieName) {
  },
  setCookie: function(cookieName, cookieValue, cookieExpire) {
  },
  deleteCookie: function(cookieName) {
  }
};

// *** Nis.Dialogs
// Consider rewrite. This code handles the balloon style dialogs and NOT the normal dialogs (Nis.Gui.Modal)
Nis.Dialogs = {
  init: function() {
    //console.log("Init Nis.Dialogs");
  },

  managerCount: 0,

  // *** Nis.Dialogs.Dialog class
  Dialog: function(id, content, options) {
    this.id = id;
    this.content = content;

    this.pos = "relative";

    if (typeof options != "undefined") {
      this.pos = options.pos;
    }
  },

  // *** Nis.Dialogs.DialogManager class
  DialogManager: function(options) {
    var manager = this;

    this.options = {};

    this.managerId = null,
      this.dialogCount = 0,
      this.$dialog = null;
    this.$arrow = null;
    this.$content = null;

    this.dialogs = $([]); // collection of shown dialogs
    this.shownDialog = null; // shown dialog

    this.offsetX = 12;
    this.offsetY = 10;
    this.animationSpeed = 50;

    this.init = function(options) {

      this.managerId = "DialogContainer_" + (Nis.Dialogs.managerCount++);

      // create the container to hold the messages
      this.$dialog = $('<div id="' + this.managerId + '" class="balloon-dialog"></div>');
      this.$arrow = $('<div class="dialog-arrow"><div class="arrow-border"></div><div class="arrow-inside"></div></div>');
      this.$content = $('<div class="dialog-content"></div>');

      this.$dialog.append(this.$arrow);
      this.$dialog.append(this.$content);
      this.$dialog.addClass('arrow-nw');

      $('body').append(this.$dialog);
    };

    this.hideDialog = function(dialog) {
      if (this.shownDialog.id == dialog.id) {
        this.$dialog.hide();
        this.shownDialog = null;
        $(document.documentElement).unbind('click', this.documentClickHandler);
      }
    };

    this.showDialog = function(dialog, callerPosition) {
      this.shownDialog = dialog;
      if (dialog.content.jQuery != 'undefined') {
        this.$content.html("").append(dialog.content); // IE needs clone here
      } else {
        this.$content.html(dialog.content);
      }

      this.$dialog.show();

      var result = this.calculateDialogPosition(dialog, callerPosition);

      this.$dialog.css({ left: result.left + "px", top: result.top + "px" });
      this.$dialog
        .removeClass('arrow-nw')
        .removeClass('arrow-ne')
        .removeClass('arrow-sw')
        .removeClass('arrow-se')
        .addClass('arrow-' + result.dir);

      this.$dialog.animate(
        { "top": "-=5px" }, this.animationSpeed
      );

      $(document.documentElement).bind('click', this.documentClickHandler);
    };

    this.calculateDialogPosition = function(dialog, callerPosition) {
        /*
        console.log("Click left: " + callerPosition.left);
        console.log("Click top: " + callerPosition.top);
        console.log("Window width: " + $(window).width());
        console.log("Window height: " + $(window).height());
        console.log("Window scrollTop: " + $(window).scrollTop());
        console.log("Window scrollLeft: " + $(window).scrollLeft());
        console.log("Dialog width: " + this.$dialog.width());
        console.log("Dialog height: " + this.$dialog.height());
        */

        // for balloon dialogs we need to keep the dialog within the viewport
        var result = {},
          cl = callerPosition.left,
          ct = callerPosition.top,
          dh = this.$dialog.height(),
          dw = this.$dialog.width(),
          wh = $(window).height(),
          ww = $(window).width(),
          st = $(window).scrollTop(),
          sl = $(window).scrollLeft(),
          pixelBelow = (wh + st) - (ct + this.offsetY),
          pixelAbove = (ct - this.offsetY) - st,
          pixelLeft = (ww + sl) - (cl + this.offsetX),
          pixelRight = (cl - this.offsetX) - sl;

        // check if we need to place above or below
        if (pixelBelow < dh && pixelAbove >= dh) {
          result.dir = "s";
          result.top = ct - dh - this.offsetY;
        } else {
          result.dir = "n";
          result.top = ct + this.offsetY;
        }

        if (pixelLeft < dw && pixelRight >= dw) {
          result.dir += "e";
          result.left = cl - dw;
        } else {
          result.dir += "w";
          result.left = cl - this.offsetX;
        }

        return result;
      },
      this.addDialog = function($elm, content, hover) {
        var dialogId = this.managerId + "_" + this.dialogCount++;
        var dialog = new Nis.Dialogs.Dialog(dialogId, content);

        // ***************************************************
        // todo: insert the content into a container
        // so we can reference it later without the clone!!
        // ***************************************************

        var showIt = function(event) {
          // if no dialog is shown
          if (manager.shownDialog == null) {
            manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
          }
          // if a different dialog is already shown
          else if (manager.shownDialog.id != dialog.id) {
            // hide the current dialog
            manager.hideDialog(manager.shownDialog);
            manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
          }
          event.stopPropagation();
          event.preventDefault();
        };

        if (hover) {
          $elm.mouseenter(function(event) { showIt(event); });
          $elm.mouseleave(function(event) { manager.hideDialog(manager.shownDialog); });
        } else
          $elm.click(function(event) { showIt(event); });

        return dialog;
      };

    this.addDialogWithCallback = function($elm, contentCallback) {
      var dialogId = this.managerId + "_" + this.dialogCount++;
      var dialog = new Nis.Dialogs.Dialog(dialogId);

      $elm.click(function(event) {
        dialog.content = contentCallback(dialog);
        // if no dialog is not shown
        if (manager.shownDialog == null) {
          manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
        }
        // if a different dialog is already shown
        else if (manager.shownDialog.id != dialog.id) {
          // hide the current dialog
          manager.hideDialog(manager.shownDialog);
          manager.showDialog(dialog, { left: event.pageX, top: event.pageY });
        }
        event.stopPropagation();
        event.preventDefault();
      });

      return dialog;
    };

    this.documentClickHandler = function(event) {
      if (manager.shownDialog != null && !$.contains(manager.$dialog.get(0), event.target)) {
        manager.hideDialog(manager.shownDialog);
      }
    };

    this.init();
  }
};



// WEBPACK FOOTER //
// ./../../Libs/WebAssets/javascripts/Nis.Gui.js